import { HeadOfficeAddressType } from "../../types/commonTypes/headOfficeAddressType";

export const headOfficeAddressInitialState: HeadOfficeAddressType = {
    address: "",
    additionalAddress: "",
    postalCode: "",
    city: "",
    registrationOffice: "",
    cities: []
}